export default __webpack_public_path__ + "static/media/iconesMinhasContratações.9c371539.png";